import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import API from "../Context/api";

function EmailVerificationNotice() {
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState(""); // "success" or "error" for styling
  const [isResending, setIsResending] = useState(false);
  const location = useLocation();
  const { email } = location.state || {};

  // Handle resending the verification email
  const handleResendVerification = async () => {
    setIsResending(true);
    try {
      if (!email) {
        setMessage("Email not found. Please sign up again.");
        setMessageType("error");
        return;
      }

      const response = await API.post("/auth/resend-email-verification", {
        email,
      });
      setMessage(response.data.message);
      setMessageType("success");
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        "An error occurred while resending the verification email.";
      setMessage(errorMessage);
      setMessageType("error");
    } finally {
      setIsResending(false);
    }
  };

  // Clear message after 5 seconds
  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        setMessage("");
        setMessageType("");
      }, 5000); // 5 seconds
      return () => clearTimeout(timer); // Cleanup on unmount or new message
    }
  }, [message]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-6 bg-white p-8 rounded-xl shadow-lg">
        {/* Message Display */}
        {message && (
          <div
            className={`text-center text-sm p-3 rounded-md ${
              messageType === "success"
                ? "bg-green-100 text-green-700"
                : "bg-red-100 text-red-700"
            }`}
          >
            {message}
          </div>
        )}

        {/* Heading */}
        <h2 className="text-center text-3xl font-bold text-gray-900">
          Verify Your Email
        </h2>

        {/* Instructions */}
        <p className="text-center text-gray-600 text-base">
          We’ve sent a verification link to{" "}
          <span className="font-medium text-indigo-600">
            {email || "your email"}
          </span>
          .
          <br />
          Please check your inbox (and spam folder) to verify your account.
          <br />
          Didn’t receive it?{" "}
          <button
            onClick={handleResendVerification}
            className={`font-medium ${
              isResending
                ? "text-gray-400 cursor-not-allowed"
                : "text-indigo-600 hover:text-indigo-800"
            }`}
            disabled={isResending}
          >
            {isResending ? "Resending..." : "Resend Verification"}
          </button>
        </p>
      </div>
    </div>
  );
}

export default EmailVerificationNotice;
